import moment from "moment-timezone";

moment.tz.setDefault("Europe/Paris");

moment.locale('fr')